import { keyframes, styled, SvgIcon } from "@mui/material";
import { FC } from "react";

interface DefaultConfirmationIconProps {
  animated?: boolean;
}

const AnimatedIcon = styled(SvgIcon, {
  skipSx: true,
  skipVariantsResolver: true
})(({ theme }) => ({
  fontSize: 220,
  color: theme.palette.secondary.main,
  strokeDasharray: 1000,
  strokeDashoffset: 1000,
  animation: `${keyframes`
    0% {
      stroke-dasharray: 1000;
      transform: scale(1);
    }
    50% {
      stroke-dasharray: 500;
      transform: scale(1);
    }
    51% {
      stroke-dasharray: 500;
      transform: scale(1);
    }
    100% {
      stroke-dasharray: 500;
      transform: scale(0.5);
    }
`} 3s cubic-bezier(0, 1.1, 0.04, 0.88) forwards`
}));

const StaticIcon = styled(SvgIcon, {
  skipSx: true,
  skipVariantsResolver: true
})(({ theme }) => ({
  fontSize: 48,
  color: theme.palette.secondary.main
}));

export const DefaultConfirmationIcon: FC<DefaultConfirmationIconProps> = ({ animated = true }) => {
  const confirmationIcon = (
    <>
      <defs>
        <style>{`.confirm{fill:none;stroke:currentColor;strokeLinecap:round;strokeLinejoin:round;strokeWidth:1.5px;}`}</style>
      </defs>
      <path className="confirm" d="M15.75,9.749l-3.981,5.308a.75.75,0,0,1-1.13.08L8.25,12.749" />
      <path
        className="confirm"
        d="M10.73,1.357L9.219,3.226A1.632,1.632 0 0 17.772,3.826L5.372,3.565A1.629,1.629 0 0 03.572,5.365L3.833,7.765A1.628,1.628 0 0 13.233,9.211L1.353,10.723A1.629,1.629 0 0 01.353,13.263L3.233,14.774A1.631,1.631 0 0 13.833,16.221L3.572,18.621A1.628,1.628 0 0 05.372,20.421L7.772,20.16A1.631,1.631 0 0 19.219,20.76L10.73,22.64A1.629,1.629 0 0 013.27,22.64L14.776,20.766A1.628,1.628 0 0 116.222,20.166L18.622,20.427A1.629,1.629 0 0 020.422,18.627L20.161,16.227A1.632,1.632 0 0 120.761,14.78L22.648,13.275A1.63,1.63 0 0 022.648,10.735L20.767,9.222A1.629,1.629 0 0 120.167,7.777L20.428,5.377A1.63,1.63 0 0 018.628,3.577L16.228,3.838A1.629,1.629 0 0 114.782,3.238L13.27,1.357A1.63,1.63 0 0 010.73,1.357"
      />
    </>
  );

  return animated ? (
    <AnimatedIcon>{confirmationIcon}</AnimatedIcon>
  ) : (
    <StaticIcon>{confirmationIcon}</StaticIcon>
  );
};
